import { EventEmitter } from 'events';

export const ModalEvents = new EventEmitter();
